export default {
    install: (app, options) => {
        app.config.globalProperties.toFixedLocal = (number: number) =>
            (Math.round(number * 100) / 100).toLocaleString(options.lang, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
};
